import styled from "styled-components";

const KycFailWrapper = styled.div`

`;

export default KycFailWrapper;
